<template>
  <div>
    <div :class="['assembly-partner d-flex align-items-center']">
      <div
          @click="removeAssembly"
          v-if="editing"
          class="settings-button d-inline-block switched-colors ml-1 ">
        <icon type="trash" />
      </div>
      <preview
          :preview-id="assemblyId"
          :asset-id="assemblyId"
          :show-label="false"
          :size="50"
          class="mb-2 bg-darker w-25"
          :removable="false"
          :downloadable="false"
      />
      <div class="right-side">
        {{ assemblyName }}
      </div>
      <!--<router-link target="_blank" class="lighter float-right" :to="'library/path/still/missing'">Go to assembly<icon type="arrow-up-right-from-square" size="0.8" /></router-link>-->
    </div>
  </div>
</template>

<script>
import Preview from "@/components/preview/Preview.vue";
import Icon from "@/components/Icon.vue";
export default {
  name: "AssemblyPartner",
  components: {
    Preview,
    Icon
  },
  props: {
    assemblyId: {type: String, required: true,},
    assemblyName: {type: String, required: true},
    selectedAssemblies: {type: Array, default: () => []},
    listName: {type: String, required: true},
    editing: {type: Boolean, default: false},
  },
  data() {
    return {
    };
  },
  methods: {
    removeAssembly() {
      this.$emit('remove', this.assemblyId);
    }
  }
}
</script>

<style lang="scss" scoped>
.assembly-partner {
  border: 1px solid rgba(255,255,255,0.2);
  padding: 2px 5px;
  border-radius: 5px;
  transition: all 300ms ease;
  background-color: var(--vform-editor-ui-secondary-color);
}
</style>